import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Form, Input } from 'antd';
import { useAppDispatch } from '../../hooks/redux';
import {
    CreatePasswordContainer,
    CreatePasswordTitle,
    CreatePasswordTitleForm,
    CreatePasswordWrapper,
    SubmitButtonContainer,
} from './CreatePassword.styles';
import CustomInput from '../../components/common/inputs/CustomInput';
import { TypographyText, SpaceCenter, PrimaryButton } from '../../styles/common.styles';
import { resetPasswordAction } from '../../redux/actions/authActions';
import { NavigationKey } from '../../components/appNavigationBar/AppNavigation.types';
import { addPages } from '../../redux/reducers/navigationReducer/NavigationSlice';

const CreatePassword: React.FC = () => {
    const dispatch = useAppDispatch();
    const history = useHistory();
    const location = useLocation();
    const params = new URLSearchParams(location.search);

    const [state, setState] = useState({
        isPasswordCreate: false,
    });

    useEffect(() => {
        dispatch(addPages([{ key: NavigationKey.HOME, value: 'SM Transparency Catalog' }]));
    }, []);

    const onSubmit = async (data: { password: string; confirmPassword: string }) => {
        const userId = params.get('id') || '';
        const key = params.get('key') || '';
        const { payload } = (await dispatch(
            resetPasswordAction({
                password: data.password,
                key,
                userId,
                confirmPassword: data.confirmPassword,
            }),
        )) as any;
        if (payload.message) {
            setState({ ...state, isPasswordCreate: true });
        }
    };

    const goToLogin = () => {
        history.push('/login');
    };

    const submitButton = () => {
        return <PrimaryButton htmlType="submit">Set new password</PrimaryButton>;
    };

    return (
        <CreatePasswordWrapper>
            {!state.isPasswordCreate ? (
                <CreatePasswordContainer>
                    <CreatePasswordTitle level={2}>Create password</CreatePasswordTitle>
                    <CreatePasswordTitleForm>
                        <TypographyText>
                            Set a password of at least 6 characters with letters and numbers. Both
                            passwords must match.
                        </TypographyText>
                    </CreatePasswordTitleForm>
                    <Form
                        name="basic"
                        labelCol={{ span: 8 }}
                        wrapperCol={{ span: 12 }}
                        initialValues={{ remember: false }}
                        onFinish={onSubmit}
                        autoComplete="off"
                    >
                        <div>
                            <CustomInput
                                Component={Input.Password}
                                label="Password"
                                name="password"
                                required
                                rules={[
                                    { required: true, message: '' },
                                    {
                                        pattern: /^(?=.*?[a-zA-Z])(?=.*?[0-9]).{6,}$/,
                                        message: 'Invalid password',
                                    },
                                ]}
                            />
                        </div>
                        <div>
                            <div id="confirm-container" className={'required'}>
                                <Form.Item
                                    name="confirmPassword"
                                    label="Confirm Password*"
                                    dependencies={['password']}
                                    validateTrigger="onBlur"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Please confirm your password!',
                                        },
                                        ({ getFieldValue }) => ({
                                            validator(_, value) {
                                                if (!value || getFieldValue('password') === value) {
                                                    return Promise.resolve();
                                                }
                                                return Promise.reject(
                                                    new Error(`Passwords don't match`),
                                                );
                                            },
                                        }),
                                    ]}
                                >
                                    <Input.Password autoComplete="new-password" />
                                </Form.Item>
                            </div>
                        </div>

                        <SubmitButtonContainer>
                            <CustomInput Component={submitButton} name="submit" label="submit" />
                        </SubmitButtonContainer>
                    </Form>
                </CreatePasswordContainer>
            ) : (
                <CreatePasswordContainer>
                    <Form.Item>
                        <SpaceCenter>
                            <TypographyText>Your password was created successfully</TypographyText>
                        </SpaceCenter>
                    </Form.Item>
                    <SpaceCenter>
                        <PrimaryButton onClick={goToLogin}>Back to login</PrimaryButton>
                    </SpaceCenter>
                </CreatePasswordContainer>
            )}
        </CreatePasswordWrapper>
    );
};

export default CreatePassword;
